import { gql } from '@apollo/client';

/** 回仓重派批次常量（与 swiftx-schedule ScheduleConstants 一致） */
export const RETURN_REDISPATCH_BATCH = 'RETURN_REDISPATCH_BATCH';
/** 默认批次常量（取不到 WMS 批次的订单） */
export const DEFAULT_BATCH = 'DEFAULT_BATCH';

/** 推送状态：0-推送中 1-成功 2-失败 */
export const PUSH_STATUS = {
    PUSHING: 0,
    SUCCESS: 1,
    FAILED: 2,
} as const;

export const GET_BATCH_PUSH_BOARD = gql`
    query GetBatchPushBoard($warehouseId: Long!) {
        board: getBatchPushBoard(warehouseId: $warehouseId) {
            pendingTotal
            returnRedispatchCount
            newArrivalCount
            entryNode
            timezone
            batches {
                wmsBatchNumber
                displayNode
                displayTime
                pendingCount
            }
            areas {
                areaId
                areaName
                dspId
                dspName
                pendingCount
                dspPendingPublishCount
            }
            cells {
                wmsBatchNumber
                areaId
                count
            }
            pushing {
                pushRecordId
                operatorName
                startedAt
            }
        }
    }
`;

export const PREVIEW_BATCH_PUSH = gql`
    query PreviewBatchPush($request: BatchPushPreviewRequestInput!) {
        preview: previewBatchPush(request: $request) {
            totalCount
            selectedTotal
            returnRedispatchCount
            newArrivalCount
            changed
            batches {
                wmsBatchNumber
                displayNode
                displayTime
                parcelCount
                selectedCount
                areaNames
            }
            cells {
                wmsBatchNumber
                areaId
                selectedCount
                currentCount
            }
        }
    }
`;

export const SUBMIT_BATCH_PUSH = gql`
    mutation SubmitBatchPush($request: BatchPushSubmitRequestInput!) {
        pushRecordId: submitBatchPush(request: $request)
    }
`;

export const GET_BATCH_PUSH_RESULT = gql`
    query GetBatchPushResult($warehouseId: Long!, $pushRecordId: Long!) {
        result: getBatchPushResult(warehouseId: $warehouseId, pushRecordId: $pushRecordId) {
            pushRecordId
            pushStatus
            parcelCount
            selectedParcelCount
            areaCount
            batchCount
            failReason
            pushedAt
        }
    }
`;

export interface BatchPushColumn {
    wmsBatchNumber: string | null;
    displayNode: string | null;
    displayTime: string | null;
    pendingCount: number | null;
}

export interface BatchPushAreaRow {
    areaId: number | null;
    areaName: string | null;
    dspId: number | null;
    dspName: string | null;
    pendingCount: number | null;
    dspPendingPublishCount: number | null;
}

export interface BatchPushCell {
    wmsBatchNumber: string | null;
    areaId: number | null;
    count: number | null;
}

/** 本仓进行中的推送（推送中） */
export interface BatchPushPushing {
    pushRecordId: number | null;
    operatorName: string | null;
    /** 发起时间（仓库当地时间） */
    startedAt: string | null;
}

export interface BatchPushBoard {
    pendingTotal: number | null;
    returnRedispatchCount: number | null;
    newArrivalCount: number | null;
    entryNode: string | null;
    timezone: string | null;
    batches: BatchPushColumn[];
    areas: BatchPushAreaRow[];
    cells: BatchPushCell[];
    /** 本仓进行中的推送；有值时「确认推送」置为 loading */
    pushing?: BatchPushPushing | null;
}

export interface GetBatchPushBoardResponse {
    board: BatchPushBoard;
}

export interface GetBatchPushBoardVariables {
    warehouseId: number;
}

export interface BatchPushCellInput {
    wmsBatchNumber: string;
    areaId: number;
    selectedCount: number;
}

export interface BatchPushPreviewBatch {
    wmsBatchNumber: string | null;
    displayNode: string | null;
    displayTime: string | null;
    parcelCount: number | null;
    selectedCount: number | null;
    areaNames: string[];
}

export interface BatchPushPreviewCell {
    wmsBatchNumber: string | null;
    areaId: number | null;
    selectedCount: number | null;
    currentCount: number | null;
}

export interface BatchPushPreview {
    totalCount: number | null;
    selectedTotal: number | null;
    returnRedispatchCount: number | null;
    newArrivalCount: number | null;
    changed: boolean | null;
    batches: BatchPushPreviewBatch[];
    cells: BatchPushPreviewCell[];
}

export interface PreviewBatchPushResponse {
    preview: BatchPushPreview;
}

export interface PreviewBatchPushVariables {
    request: {
        warehouseId: number;
        cells: BatchPushCellInput[];
    };
}

export interface SubmitBatchPushResponse {
    pushRecordId: number;
}

export interface SubmitBatchPushVariables {
    request: {
        warehouseId: number;
        requestNo: string;
        cells: BatchPushCellInput[];
    };
}

export interface BatchPushResult {
    pushRecordId: number | null;
    pushStatus: number | null;
    parcelCount: number | null;
    selectedParcelCount: number | null;
    areaCount: number | null;
    batchCount: number | null;
    failReason: string | null;
    pushedAt: string | null;
}

export interface GetBatchPushResultResponse {
    result: BatchPushResult;
}

export interface GetBatchPushResultVariables {
    warehouseId: number;
    pushRecordId: number;
}
